import { render, staticRenderFns } from "./AtributosJerarquiaModal.vue?vue&type=template&id=7275b734&scoped=true"
import script from "./AtributosJerarquiaModal.vue?vue&type=script&lang=js"
export * from "./AtributosJerarquiaModal.vue?vue&type=script&lang=js"
import style0 from "./AtributosJerarquiaModal.vue?vue&type=style&index=0&id=7275b734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275b734",
  null
  
)

export default component.exports